<template>
  <li class="flex flex-row justify-start items-center">
    <div class="bg-indigo-600 h-2 w-2 rounded-full mr-2.5"></div>
    <div class="flex flex-col">
      <span class="font-medium text-base">{{ textContent }}</span>
      <span class="italic">{{ details }}</span>
    </div>
  </li>
</template>
<script>
export default {
  props: {
    content: {
      type: String,
      required: true
    }
  },

  computed: {
    textContent() {
      let start = this.content.indexOf('(');

      if (start > -1) {
        return this.content.slice(0, start);
      }

      return this.content;
    },

    details() {
      let start = this.content.indexOf('(');

      if (start > -1) {
        return this.content.slice(start);
      }

      return '';
    }
  }
};
</script>
